module.exports = __webpack_public_path__ + "static/media/pukhtunkhwa.73d7ec84.png";